import { Injectable } from '@angular/core';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class IconRegistryService {
  constructor(private readonly iconRegistry: MatIconRegistry, private readonly sanitizer: DomSanitizer) {}

  setCustomIcons() {
    //#region Menu Icons

    this.iconRegistry.addSvgIcon('resume', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/menu/resume.svg`));
    this.iconRegistry.addSvgIcon('onboarding', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/menu/onboarding_new.svg`));
    this.iconRegistry.addSvgIcon('rappi_accounts', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/menu/rappi_accounts.svg`));
    this.iconRegistry.addSvgIcon('contracts', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/menu/contracts.svg`));
    this.iconRegistry.addSvgIcon('calls', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/menu/calls.svg`));
    this.iconRegistry.addSvgIcon('card_delivery', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/menu/card_delivery.svg`));
    this.iconRegistry.addSvgIcon('bill_payments', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/menu/bill_payments.svg`));
    this.iconRegistry.addSvgIcon('clarification', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/menu/clarification.svg`));

    //#endregion

    //#region Actions
    this.iconRegistry.addSvgIcon('call_action', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/call_action.svg`));
    this.iconRegistry.addSvgIcon('call_action_disabled', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/call_action_gray.svg`));
    this.iconRegistry.addSvgIcon('auth_action', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/auth.svg`));
    this.iconRegistry.addSvgIcon('auth_disabled_action', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/auth_disabled.svg`));
    //#endregion

    //#region General

    this.iconRegistry.addSvgIcon(
      'moustache_card_black',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/moustache_card_black.svg`)
    );
    this.iconRegistry.addSvgIcon(
      'moustache_card_primary',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/moustache_card_primary.svg`)
    );
    this.iconRegistry.addSvgIcon(
      'moustache_card_gray',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/moustache_card_gray.svg`)
    );
    this.iconRegistry.addSvgIcon('rappi_card', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/credit_card_primary.svg`));
    this.iconRegistry.addSvgIcon('loans', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/loans.svg`));
    this.iconRegistry.addSvgIcon('loans_primary', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/loans_primary.svg`));
    this.iconRegistry.addSvgIcon('loans_gray', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/loans_gray.svg`));
    this.iconRegistry.addSvgIcon('gpp_good_primary', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/gpp_good_primary.svg`));
    this.iconRegistry.addSvgIcon('gpp_good_gray', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/gpp_good_gray.svg`));
    this.iconRegistry.addSvgIcon('rappi_circle_black', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/rappi_circle_black.svg`));
    this.iconRegistry.addSvgIcon(
      'rappi_circle_primary',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/rappi_circle_primary.svg`)
    );
    this.iconRegistry.addSvgIcon('rappi_circle_gray', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/rappi_circle_gray.svg`));
    this.iconRegistry.addSvgIcon('move', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/move_icon.svg`));
    //#endregion

    //this.iconRegistry.addSvgIcon('debit_card', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/debit_card.svg`));

    //#region Actions Buttons
    this.iconRegistry.addSvgIcon('certificates', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/certificates.svg`));
    this.iconRegistry.addSvgIcon(
      'certificates_disabled',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/certificates_disabled.svg`)
    );
    this.iconRegistry.addSvgIcon('document_check', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/document_check.svg`));
    this.iconRegistry.addSvgIcon(
      'document_check_disabled',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/document_check_disabled.svg`)
    );
    this.iconRegistry.addSvgIcon('lock', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/lock.svg`));
    this.iconRegistry.addSvgIcon('trash', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/trash.svg`));
    this.iconRegistry.addSvgIcon('trash_disabled', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/trash_disabled.svg`));
    this.iconRegistry.addSvgIcon('withdraw', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/withdraw.svg`));
    this.iconRegistry.addSvgIcon(
      'withdraw_disabled',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/withdraw_disabled.svg`)
    );
    this.iconRegistry.addSvgIcon('statement', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/statement.svg`));
    this.iconRegistry.addSvgIcon('unlock', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/unlock.svg`));
    this.iconRegistry.addSvgIcon('ac_unit', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/ac_unit.svg`));
    this.iconRegistry.addSvgIcon('ac_unit_frozen', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/ac_unit_frozen.svg`));
    this.iconRegistry.addSvgIcon(
      'freeze_disabled',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/freeze_disabled.svg`)
    );
    this.iconRegistry.addSvgIcon('refresh', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/refresh.svg`));
    this.iconRegistry.addSvgIcon(
      'refresh_disabled',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/refresh_disabled.svg`)
    );
    this.iconRegistry.addSvgIcon('settings', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/settings.svg`));
    this.iconRegistry.addSvgIcon(
      'settings_disabled',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/settings_disabled.svg`)
    );
    this.iconRegistry.addSvgIcon('rappi_courier', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/rappi_courier.svg`));
    this.iconRegistry.addSvgIcon(
      'external_courier',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/actions/external_courier.svg`)
    );
    this.iconRegistry.addSvgIcon('icon_info_rpp', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/icon_info.svg`));
    //#endregion

    //#region natural and juridical icons
    this.iconRegistry.addSvgIcon('natural', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/profile_black.svg`));
    this.iconRegistry.addSvgIcon('business', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/shop_black.svg`));
    this.iconRegistry.addSvgIcon('natural_selected', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/profile.svg`));
    this.iconRegistry.addSvgIcon('business_selected', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/shop.svg`));
    this.iconRegistry.addSvgIcon('business_teams', this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/business_teams_black.svg`));
    this.iconRegistry.addSvgIcon(
      'business_teams_selected',
      this.sanitizer.bypassSecurityTrustResourceUrl(`/assets/svg/business_teams.svg`)
    );
    //#endregion
  }
}
